
<template>
    <div class="p-grid p-fluid">
      <div class="p-col-12">
        <h2 class="p-mb-1">{{ saudacao }}</h2> 
      </div>
      <!--Marcar ponto-->
      <div class="p-col-12">
        <div class="card p-shadow-1">
          <h5>{{ descricaoData }}</h5>
          <div class="p-grid p-fluid">         
            <div class="p-col-12" v-if="agent && agent.mobile">
              <div class="p-d-flex p-jc-center">               
                <span class="p-text-bold" style="font-size: 3.5rem;">{{ time }}</span>  
              </div>        
            </div>
            <div class="p-col-6" v-else>
              <div class="p-d-flex p-jc-end">
                <i class="pi pi-clock p-mr-5" style="font-size: 3rem; margin-top: 14px;"></i>
                <span class="p-text-bold" style="font-size: 3.5rem;">{{ time }}</span>  
              </div>        
            </div>
            <div class="p-col-6" :class="(agent && agent.mobile) ? 'p-col-12' : 'p-col-6'" v-if="exibirBotaoRegistro">  
              <Button label="Registrar Ponto" icon="pi pi-clock" 
                class="p-button-primary p-mt-4"
                @click="getDataHoraRegistro" v-if="agent && agent.mobile"/>
                <Button label="Registrar Ponto" icon="pi pi-clock" 
                class="p-button-primary p-mt-4 p-ml-4" style="width: 150px;" 
                @click="getDataHoraRegistro" v-else/>
            </div>
            <div v-else>
              <Message severity="error" :closable="false" v-if="exibirMensagemGeolocalizacao">
                  <span style="font-size: 16px;">O sistema precisa da sua localização para Registrar o Ponto.</span>
              </Message> 
            </div>
          </div>        
        </div>
      </div>  
      
      <Resumo ref="resumo"/>
  
      <Dialog :visible.sync="exibirModalConfirmacaoHora" header="Registro de Ponto" :modal="true" class="ik-dialog-confirmar-registro">
        <div class="confirmation-content">
          <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem;" />
          <span>Confirmar Registro de Ponto?</span>        
          <div class="p-d-flex p-jc-center">         
            <span class="p-text-bold" style="font-size: 3.5rem;">{{ horaSelecionada }}</span>  
          </div> 
        </div>
        <template #footer>
          <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirModalConfirmacaoHora=false"/>
          <Button label="Sim" icon="pi pi-check" @click="salvar" />
        </template>
      </Dialog>
  
      <Dialog :visible.sync="exibirModalSucessoRegistroHora" header="Registro de Ponto" :modal="true" class="ik-dialog-confirmar-registro">
        <div class="confirmation-content">      
          <Message severity="warn" :closable="false"><span style="font-size: 16px;">Aguarde!</span></Message>         
          <p>Tempo estimado para a atualização do ponto: entre 5 e 15 minutos após o registro.</p>
        </div>
        <template #footer>       
          <Button label="OK" icon="pi pi-check" @click="exibirModalSucessoRegistroHora=false" />
        </template>
      </Dialog>
  
    </div>
  </template>
  
  <script>
  import Resumo from '@/components/pages/dashboard/Resumo.vue';
  import GeolocalizacaoService from '@/service/GeolocalizacaoService.js';
  import PontoService from '@/service/PontoService';
  import { exibirMensagem, exibirMensagemSis } from '@/global';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
      geolocalizacaoService: null,    
      pontoService: null,
      data() {
          return {
            exibirModalConfirmacaoHora: false,
            exibirModalSucessoRegistroHora: false,
            registroMarcacao: null,
            horaSelecionada: '',
            descricaoData: '',
            saudacao: 'Olá',
            time: new Date(),        
            timeZone: null,
            dateTimeNow: 0,
            idTimeoutUpNow: null,
            stopTimeoutUpNow: false,
            idTimeoutTimeZone: null,
            stopTimeoutTimeZone: false,
            exibirBotaoRegistro: false,
            exibirMensagemGeolocalizacao: true,
            longitude: '',
            latitude: '',
            enderecoRegistro: '',
            agent: null
          }
      },
      methods: {
        ...mapGetters('sessao', ['getUsuario']),
        ...mapActions('sessao', ['limparSessao']),
        /**
        * 
        */
        upNow() {            
          if(this.$router.history.current.path != '/') {
            this.limparTimeouts();
            return;
          }
          this.idTimeoutUpNow = setTimeout(() => {
            if(this.stopTimeoutUpNow) {
              return;
            }
            if(this.$router.history.current.path != '/') {
              this.limparTimeouts();
              return;
            }
            this.dateTimeNow.setSeconds(this.dateTimeNow.getSeconds() + 1)
            this.formatarSaudacao();
            this.upNow();
          }, 999);
        },
        /**
        *       
        */
        upSaudacao() {    
          const options = { timeZone: this.timeZone, weekday: "long", year: "numeric", month: "long", day: "numeric" };    
          this.descricaoData = this.dateTimeNow.toLocaleDateString('pt-BR', options);
          let h = this.dateTimeNow.getHours();
          if (h <= 5) return 'Boa madrugada';
          if (h < 12) return 'Bom dia';
          if (h < 18) return 'Boa tarde';
          return 'Boa noite';
        },      
        /**
        * 
        */
        now() {
          if(this.$router.history.current.path != '/') {
            this.limparTimeouts();
            return;
          }       
          this.stopTimeoutUpNow = true;    
          clearTimeout(this.idTimeoutUpNow);
          this.dateTimeNow = new Date()          
          this.stopTimeoutUpNow = false;
          this.time =  this.dateTimeNow.toLocaleTimeString('pt-BR');
          this.upNow();      
          this.idTimeoutTimeZone = setTimeout(() => {
            if(this.$router.history.current.path != '/') {
              this.limparTimeouts();
              return;
            }
            this.now();
          }, 15000);            
        },
        /**
         * 
         */
        getDataHoraRegistro() {          
          let date = new Date();
          this.registroMarcacao = this.criarObjMarcacao(date);  
          let options = { hour: 'numeric', minute: 'numeric' };
          this.horaSelecionada = date.toLocaleTimeString('pt-BR', options);     
          this.exibirModalConfirmacaoHora = true;           
        },
        /**
         * 
         */
        salvar() {
          if(!this.registroMarcacao) {
            exibirMensagemSis(this, 'Não selecionou a hora', true);
            return;
          }  
          this.geolocalizacaoService.getLongLat(this.latitude, this.longitude)
          .then(resp => {
            this.registroMarcacao
            .coletas[0]
            .dias[0]
            .marcacoes[0].local = resp.data.results[0].formatted_address;            
            // registro
            this.pontoService.registrar(this.registroMarcacao)
            .then(resp => {
              exibirMensagem(this, resp);
              this.exibirModalSucessoRegistroHora = true;
              this.exibirModalConfirmacaoHora = false;
              setTimeout(() => {
                  this.$refs.resumo.getEspelho();
              }, 60000);
            })
            .catch(erro => {
              if(erro.response.status == 401) {
                this.logout();
              } else {
                exibirMensagem(this, erro)
              }  
            });  
            //registro          
          })
          .catch(erro => {
            if(erro.response.status == 401) {
                this.logout();
            } else {
                exibirMensagem(this, erro)
            }              
          });  
        },
        /**
         * 
         */    
        geolocalizacao() {
          if(!this.getUsuario().permissoes.registrarPonto) {
            this.exibirMensagemGeolocalizacao = false;
            return;
          }
          this.exibirMensagemGeolocalizacao = true;
          let thisVue = this;
          if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
            function(position) {
              thisVue.longitude = position.coords.longitude;
              thisVue.latitude = position.coords.latitude;   
              if(thisVue.longitude && thisVue.latitude) {
                thisVue.exibirBotaoRegistro = true;
              }           
            }, 
            function(error) {
              switch(error.code) {
                case error.PERMISSION_DENIED:
                  exibirMensagemSis(thisVue, 'Usuário rejeitou a solicitação de Geolocalização.', true);
                break;
                case error.POSITION_UNAVAILABLE:
                  exibirMensagemSis(thisVue, 'Localização indisponível.', true);
                break;
                case error.TIMEOUT:
                  exibirMensagemSis(thisVue, 'O tempo da requisição expirou.', true);
                break;
                case error.UNKNOWN_ERROR:
                  exibirMensagemSis(thisVue, 'Algum erro desconhecido aconteceu.', true);
                break;
              }
            });
          } else {
            exibirMensagemSis(thisVue, 'Desculpe, seu navegador não suporta serviços de geolocalização. Atualize o navegador.', true);
          }
        },     
        /**
         * 
         * @param {*} date 
         */
        criarObjMarcacao(date) {          
          let options = { hour: 'numeric', minute: 'numeric' };
          let hora = date.toLocaleTimeString('pt-BR', options);
          let data = this.formatarData(date);
          let dataHora = data + ' ' + hora;
          let usuario = this.getUsuario();
          return {
            grupo: usuario.grupo,
            id: usuario.id,
            dataInicio: data,
            dataFinal: data,
            cnpj: usuario.numeroCnpj,         
            tipoDispositivo: 'Web',
            coletas: [
                {
                  pis: usuario.pis,
                  dias: [
                      {
                        dia: data,
                        marcacoes: [
                            {
                              dia: data,
                              dataHora: dataHora,                           
                              pis: usuario.pis,
                              numCnpj: usuario.numeroCnpj,
                              fonte: 'R',
                              externa: true,
                              latitude: this.latitude,
                              longitude: this.longitude,
                              local:  this.enderecoRegistro,
                              online:  true
                            }
                        ]
                      }
                  ]
                }
            ]
          };
        }, 
        /**
        * 
        */
        formatarSaudacao() { 
          this.time = this.dateTimeNow.toLocaleTimeString('pt-BR');
          if(this.saudacao == 'Olá' || this.dateTimeNow.getMinutes() == 0) {
            this.saudacao = this.upSaudacao();
          }
        },
        /**
         * 
         * @param {*} data 
         */
        formatarData(data) {
          if(!data) {
            return null;
          }
          let strData = null;
          if(data instanceof Date) {
            let dt = data;
            let mes = dt.getMonth();
            let dia = dt.getDate();
            strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
          } else {
            let partes = data.split('/');
            strData = partes[2] + '-' + partes[1] + '-' + partes[0];
          }
          return strData;
        },
        /**
         * 
         */
        limparTimeouts() {
          this.stopTimeoutUpNow = false;        
          this.stopTimeoutTimeZone = false,
          clearTimeout(this.idTimeoutTimeZone);
          clearTimeout(this.idTimeoutUpNow);
        },
        /**
         * 
         */
        logout() {
          this.limparSessao();			
          this.$router.push('/login?exp=sessao_expirada');
        }
      },
      created() {
        this.agent = JSON.parse(sessionStorage.getItem('AGENT_WEB_MOBILE'));
        this.geolocalizacaoService = new GeolocalizacaoService();
        this.pontoService = new PontoService();             
        this.limparTimeouts();
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;    
        this.time = new Date().toLocaleTimeString('pt-BR')
        this.now();
        this.geolocalizacao();
      },
      components: {
        Resumo
      }
  }
  </script>
  
  <style>
  
  </style>